class ProductBundles extends HTMLElement {
    constructor() {
        super();
        this.items = this.querySelectorAll('.item');
        this.controlls = this.querySelectorAll('input[type="radio"], input[type="checkbox"], .quantity__input')
        this.plusButtons = this.querySelectorAll('.quantity__button[name="plus"]')
        this.progressContainer = this.querySelector('.progress .container')
        this.formSubmits = this.querySelectorAll('.product-form__submit')
        this.sampleItems = this.querySelectorAll('.sample-wrapper .sample:not(.free-product)')
        this.sampleFreeItems = this.querySelectorAll('.sample-wrapper .sample.free-product')
        this.additionalVariant = this.querySelectorAll('[name="properties[__additional]"]')
        
        if(this.dataset.type == 'variants') {
            document.addEventListener('DOMContentLoaded', this.initializeVariants.bind(this))
        } else if(this.dataset.type == 'products') {
            document.addEventListener('DOMContentLoaded', this.initializeProducts.bind(this))
        } else if(this.dataset.type == 'groups') {
            document.addEventListener('DOMContentLoaded', this.initializeGroups.bind(this))
        }
    }
    
    initializeGroups() {
        if(this.controlls.length > 0) {
            this.controlls.forEach((control)=>{
                control.addEventListener('change', this.processGroups.bind(this))
            })
        }
        this.sampleItems.forEach((sampleItem)=>{
            let _self = this;
            sampleItem.addEventListener('click',function(){
                _self.sampleItems.forEach((si)=>{
                    if(si == sampleItem) {
                        si.classList.add('active')
                        _self.querySelector('.items[data-index="' + si.dataset.index + '"]').classList.add('active')
                    } else {
                        si.classList.remove('active')
                        _self.querySelector('.items[data-index="' + si.dataset.index + '"]').classList.remove('active')
                    }
                })
            })
        })
    }

    initializeProducts() {
        if(this.controlls.length > 0) {
            this.controlls.forEach((control)=>{
                control.addEventListener('change', this.processProducts.bind(this))
            })
        }
        this.sampleItems.forEach((sampleItem)=>{
            let _self = this;
            sampleItem.addEventListener('click',function(){
                _self.sampleItems.forEach((si)=>{
                    if(si == sampleItem) {
                        si.classList.add('active')
                        _self.querySelector('.items[data-index="' + si.dataset.index + '"]').classList.add('active')
                    } else {
                        si.classList.remove('active')
                        _self.querySelector('.items[data-index="' + si.dataset.index + '"]').classList.remove('active')
                    }
                })
            })
        })
    }

    processGroups(event) {
        let control = event.target;
        let item = control.closest('.item')
        let current = item.parentElement.dataset.index
        let currentIndex = item.parentElement.dataset.index - 1
        let quantities = this.querySelectorAll('.quantity__input')
        let totalQty = 0, qty = 0, index = 1;
        let skusString = '';
        let productForm = this.querySelector('.product-form form')
        let productFormProperties = this.querySelectorAll('.product-form .properties')
        if(productFormProperties.length > 0) {
            productFormProperties.forEach((input)=>{
                input.remove()
            })
        }
        this.sampleItems[currentIndex].querySelector('.sample-name').innerText = ''
        this.sampleItems[currentIndex].querySelector('.aura').dataset.fragrance = ''
        this.sampleItems[currentIndex].classList.remove('active')
        quantities.forEach((quantity)=>{
            let item = quantity.closest('.item')
            let checkbox = item.querySelector('input[type="radio"]')
            if(checkbox?.checked) {
                let variantId = item.dataset.variantId
                let sku = item.dataset.sku
                let fragrance = item.dataset.fragrance
                let variantTitle = item.querySelector('.title').innerText
                // let productTitle = item.querySelector('.title').dataset.title
                let newCurrentIndex = quantity.dataset.index - 1
                totalQty+= parseInt(quantity.value)
                if(quantity.dataset.index == current) {
                    qty+= parseInt(quantity.value)
                }
                
                this.sampleItems[newCurrentIndex].querySelector('.sample-name').innerText = variantTitle
                this.sampleItems[newCurrentIndex].querySelector('.aura').dataset.fragrance = fragrance
                if(newCurrentIndex == currentIndex) {
                    this.sampleItems[currentIndex].classList.add('active')
                }
                
                let input2 = document.createElement("input");
                input2.setAttribute('type', 'hidden');
                input2.setAttribute('name', 'properties[__samples][' + variantId + ']');
                input2.setAttribute('value', quantity.value);
                input2.classList.add('properties')
                productForm.appendChild(input2);
                let input = document.createElement("input");
                input.setAttribute('type', 'hidden');
                input.setAttribute('name', 'properties[' + index + ']');
                input.setAttribute('value', quantity.value + 'x ' + variantTitle);
                input.classList.add('properties')
                productForm.appendChild(input);
                index++
                skusString += `${quantity.value}x${sku};`
            } else {
                item.querySelector('.quantity__input').value = 1
            }
        })

        this.sampleFreeItems.forEach((item) => {
            let variantId = item.dataset.variantId
            let sku = item.dataset.sku
            let productTitle = item.dataset.productTitle
            
            let input2 = document.createElement("input");
            input2.setAttribute('type', 'hidden');
            input2.setAttribute('name', 'properties[__samples][' + variantId + ']');
            input2.setAttribute('value', 1);
            input2.classList.add('properties')
            productForm.appendChild(input2);
            let input = document.createElement("input");
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', 'properties[' + index + ']');
            input.setAttribute('value', 1 + 'x ' + productTitle);
            input.classList.add('properties')
            productForm.appendChild(input);
            skusString += `1x${sku};`
            index++
        })

        if(this.additionalVariant.length > 0) {
            this.additionalVariant.forEach((item) => {
                let sku = item.dataset.sku
                skusString += `1x${sku};`
                console.log(item.value)
            })
        }

        if(skusString.length > 0) {
            let input3 = document.createElement("input");
            input3.setAttribute('type', 'hidden');
            input3.setAttribute('name', 'properties[__skus]');
            input3.setAttribute('value', '1xBLANK;' + skusString + '1xBLANK;');
            input3.classList.add('properties')
            productForm.appendChild(input3);
    }
        
        if(item.parentElement.nextElementSibling && qty == this.dataset.itemLimit) {
            item.parentElement.classList.remove('active')
            item.parentElement.nextElementSibling.classList.add('active')
            this.sampleItems[currentIndex].classList.remove('active')
            this.sampleItems[item.parentElement.nextElementSibling.dataset.index - 1].classList.add('active')
        }
        let unchecked = this.querySelectorAll('input[type="checkbox"]:not(:checked)')
        let progreeePercent = parseInt(100 / this.dataset.totalLimit * totalQty)
        this.progressContainer.style.width = progreeePercent + '%'
        if(progreeePercent > 0) {
            this.progressContainer.classList.add('active')
        } else {
            this.progressContainer.classList.remove('active')
        }
        if(totalQty == this.dataset.totalLimit) {
            this.progressContainer.parentElement.classList.add('complete')
            this.progressContainer.querySelector('.number').innerText = 100
            this.plusButtons.forEach((button)=>{
                button.setAttribute('disabled', 'disabled')
            })
            unchecked.forEach((button)=>{
                button.setAttribute('disabled', 'disabled')
            })
            this.formSubmits.forEach((formSubmit)=>{
                formSubmit.removeAttribute('disabled')
            })
        } else {
            this.progressContainer.parentElement.classList.add('active')
            this.progressContainer.parentElement.classList.remove('complete')
            this.progressContainer.querySelector('.number').innerText = progreeePercent
            this.plusButtons.forEach((button)=>{
                button.removeAttribute('disabled')
            })
            unchecked.forEach((button)=>{
                button.removeAttribute('disabled')
            })
            this.formSubmits.forEach((formSubmit)=>{
                formSubmit.setAttribute('disabled', 'disabled')
            })
        }    
    }

    processProducts(event) {
        let control = event.target;
        let skusString = '';
        let item = control.closest('.item')
        let current = item.parentElement.dataset.index
        let currentIndex = item.parentElement.dataset.index - 1
        let quantities = this.querySelectorAll('.quantity__input')
        let totalQty = 0, qty = 0, index = 1;
        let productForm = this.querySelector('.product-form form')
        let productFormProperties = this.querySelectorAll('.product-form .properties')
        if(productFormProperties.length > 0) {
            productFormProperties.forEach((input)=>{
                input.remove()
            })
        }
        this.sampleItems[currentIndex].querySelector('.sample-name').innerText = ''
        this.sampleItems[currentIndex].querySelector('.aura').dataset.fragrance = ''
        this.sampleItems[currentIndex].classList.remove('active')
        quantities.forEach((quantity)=>{
            let item = quantity.closest('.item')
            let checkbox = item.querySelector('input[type="radio"]')
            if(checkbox?.checked) {
                let variantId = item.dataset.variantId
                let sku = item.dataset.sku
                let fragrance = item.dataset.fragrance
                let variantTitle = item.querySelector('.title').innerText
                let productTitle = item.querySelector('.title').dataset.title
                let newCurrentIndex = quantity.dataset.index - 1
                totalQty+= parseInt(quantity.value)
                if(quantity.dataset.index == current) {
                    qty+= parseInt(quantity.value)
                }
                
                this.sampleItems[newCurrentIndex].querySelector('.sample-name').innerText = variantTitle
                this.sampleItems[newCurrentIndex].querySelector('.aura').dataset.fragrance = fragrance
                if(newCurrentIndex == currentIndex) {
                    this.sampleItems[currentIndex].classList.add('active')
                }
                
                let input2 = document.createElement("input");
                input2.setAttribute('type', 'hidden');
                input2.setAttribute('name', 'properties[__samples][' + variantId + ']');
                input2.setAttribute('value', quantity.value);
                input2.classList.add('properties')
                productForm.appendChild(input2);
                let input = document.createElement("input");
                input.setAttribute('type', 'hidden');
                input.setAttribute('name', 'properties[' + index + ']');
                input.setAttribute('value', quantity.value + 'x ' + productTitle + ' ' + variantTitle);
                input.classList.add('properties')
                productForm.appendChild(input);
                skusString += `${quantity.value}x${sku};`
                index++
            } else {
                item.querySelector('.quantity__input').value = 1
            }
        })
        this.sampleFreeItems.forEach((item) => {
            let variantId = item.dataset.variantId
            let sku = item.dataset.sku
            let productTitle = item.dataset.productTitle
            
            let input2 = document.createElement("input");
            input2.setAttribute('type', 'hidden');
            input2.setAttribute('name', 'properties[__samples][' + variantId + ']');
            input2.setAttribute('value', 1);
            input2.classList.add('properties')
            productForm.appendChild(input2);
            let input = document.createElement("input");
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', 'properties[' + index + ']');
            input.setAttribute('value', 1 + 'x ' + productTitle);
            input.classList.add('properties')
            productForm.appendChild(input);
            skusString += `1x${sku};`
            index++
        })

        if(this.additionalVariant.length > 0) {
            this.additionalVariant.forEach((item) => {
                let sku = item.dataset.sku
                skusString += `1x${sku};`
                console.log(item.value)
            })
        }

        if(skusString.length > 0) {
            let input3 = document.createElement("input");
            input3.setAttribute('type', 'hidden');
            input3.setAttribute('name', 'properties[__skus]');
            input3.setAttribute('value', '1xBLANK;' + skusString + '1xBLANK;');
            input3.classList.add('properties')
            productForm.appendChild(input3);
        }

        if(item.parentElement.nextElementSibling && qty == this.dataset.itemLimit) {
            item.parentElement.classList.remove('active')
            item.parentElement.nextElementSibling.classList.add('active')
            this.sampleItems[currentIndex].classList.remove('active')
            this.sampleItems[item.parentElement.nextElementSibling.dataset.index - 1].classList.add('active')
        }
        let unchecked = this.querySelectorAll('input[type="checkbox"]:not(:checked)')
        let progreeePercent = parseInt(100 / this.dataset.totalLimit * totalQty)
        this.progressContainer.style.width = progreeePercent + '%'
        if(progreeePercent > 0) {
            this.progressContainer.classList.add('active')
        } else {
            this.progressContainer.classList.remove('active')
        }
        if(totalQty == this.dataset.totalLimit) {
            this.progressContainer.parentElement.classList.add('complete')
            this.progressContainer.querySelector('.number').innerText = 100
            this.plusButtons.forEach((button)=>{
                button.setAttribute('disabled', 'disabled')
            })
            unchecked.forEach((button)=>{
                button.setAttribute('disabled', 'disabled')
            })
            this.formSubmits.forEach((formSubmit)=>{
                formSubmit.removeAttribute('disabled')
            })
        } else {
            this.progressContainer.parentElement.classList.add('active')
            this.progressContainer.parentElement.classList.remove('complete')
            this.progressContainer.querySelector('.number').innerText = progreeePercent
            this.plusButtons.forEach((button)=>{
                button.removeAttribute('disabled')
            })
            unchecked.forEach((button)=>{
                button.removeAttribute('disabled')
            })
            this.formSubmits.forEach((formSubmit)=>{
                formSubmit.setAttribute('disabled', 'disabled')
            })
        }    
    }

    initializeVariants() {
        if(this.controlls.length > 0) {
            this.controlls.forEach((control)=>{
                control.addEventListener('change', this.processVariants.bind(this))
            })
        }
    }

    processVariants() {
        let quantities = this.querySelectorAll('.quantity__input')
        let skusString = '';
        // let sampleItems = this.querySelectorAll('.sample-wrapper .sample')
        let current = 0, totalQty = 0, index = 1;
        let productForm = this.querySelector('.product-form form')
        let productFormProperties = this.querySelectorAll('.product-form .properties')
        if(productFormProperties.length > 0) {
            productFormProperties.forEach((input)=>{
                input.remove()
            })
        }
        quantities.forEach((quantity)=>{
            let item = quantity.closest('.item')
            let checkbox = item.querySelector('input[type="checkbox"]')
            if(quantity.value == 0) {
                checkbox.checked = false
            }
            if(checkbox?.checked) {
                let variantId = item.dataset.variantId
                let sku = item.dataset.sku
                let fragrance = item.dataset.fragrance
                let variantTitle = item.querySelector('.title').innerText
                totalQty+= parseInt(quantity.value)
                for(let i = 0; i < quantity.value; i++) {
                    this.sampleItems[current].querySelector('.sample-name').innerText = variantTitle
                    this.sampleItems[current].querySelector('.aura').dataset.fragrance = fragrance
                    this.sampleItems[current].classList.add('active')
                    current++;
                }
                let input2 = document.createElement("input");
                input2.setAttribute('type', 'hidden');
                input2.setAttribute('name', 'properties[__samples][' + variantId + ']');
                input2.setAttribute('value', quantity.value);
                input2.classList.add('properties')
                productForm.appendChild(input2);
                let input = document.createElement("input");
                input.setAttribute('type', 'hidden');
                input.setAttribute('name', 'properties[' + index + ']');
                input.setAttribute('value', quantity.value + 'x ' + variantTitle);
                input.classList.add('properties')
                productForm.appendChild(input);
                skusString += `${quantity.value}x${sku};`
                index++
            } else {
                item.querySelector('.quantity__input').value = 1
            }
        })
        
        this.sampleFreeItems.forEach((item) => {
            let variantId = item.dataset.variantId
            let sku = item.dataset.sku
            let productTitle = item.dataset.productTitle
            
            let input2 = document.createElement("input");
            input2.setAttribute('type', 'hidden');
            input2.setAttribute('name', 'properties[__samples][' + variantId + ']');
            input2.setAttribute('value', 1);
            input2.classList.add('properties')
            productForm.appendChild(input2);
            let input = document.createElement("input");
            input.setAttribute('type', 'hidden');
            input.setAttribute('name', 'properties[' + index + ']');
            input.setAttribute('value', 1 + 'x ' + productTitle);
            input.classList.add('properties')
            productForm.appendChild(input);
            skusString += `1x${sku};`
            index++
        })

        if(this.additionalVariant.length > 0) {
            this.additionalVariant.forEach((item) => {
                let sku = item.dataset.sku
                skusString += `1x${sku};`
                console.log(item.value)
            })
        }

        if(skusString.length > 0) {
            let input3 = document.createElement("input");
            input3.setAttribute('type', 'hidden');
            input3.setAttribute('name', 'properties[__skus]');
            input3.setAttribute('value', '1xBLANK;' + skusString + '1xBLANK;');
            input3.classList.add('properties')
            productForm.appendChild(input3);
        }

        for(let i = current; i < this.dataset.totalLimit; i++) {
            this.sampleItems[i].querySelector('.sample-name').innerText = ''
            this.sampleItems[i].querySelector('.aura').dataset.fragrance = ''
            this.sampleItems[i].classList.remove('active')
        }
        let unchecked = this.querySelectorAll('input[type="checkbox"]:not(:checked)')
        let progreeePercent = parseInt(100 /  this.dataset.totalLimit * totalQty)
        this.progressContainer.style.width = progreeePercent + '%'
        if(progreeePercent > 0) {
            this.progressContainer.classList.add('active')
        } else {
            this.progressContainer.classList.remove('active')
        }
        if(totalQty ==  this.dataset.totalLimit) {
            this.progressContainer.parentElement.classList.add('complete')
            this.progressContainer.querySelector('.number').innerText = 100
            this.plusButtons.forEach((button)=>{
                button.setAttribute('disabled', 'disabled')
            })
            unchecked.forEach((button)=>{
                button.setAttribute('disabled', 'disabled')
            })
            this.formSubmits.forEach((formSubmit)=>{
                formSubmit.removeAttribute('disabled')
            })
        } else {
            this.progressContainer.parentElement.classList.add('active')
            this.progressContainer.parentElement.classList.remove('complete')
            this.progressContainer.querySelector('.number').innerText = progreeePercent
            this.plusButtons.forEach((button)=>{
                button.removeAttribute('disabled')
            })
            unchecked.forEach((button)=>{
                const it = button.closest('.item')
                if(it.dataset.available == 'false') {
                    button.setAttribute('disabled', 'disabled')
                } else {
                    button.removeAttribute('disabled')
                }
            })
            this.formSubmits.forEach((formSubmit)=>{
                formSubmit.setAttribute('disabled', 'disabled')
            })
        }
    }
}
customElements.define('product-bundles', ProductBundles);